export { InitializeAutoAtlAnalytics } from "./initialize-auto-atl-analytics";
